import {Component, EventEmitter, HostListener, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'l-lcr-page-layout',
  templateUrl: './l-c-r-page-layout.component.html',
  styleUrls: ['./l-c-r-page-layout.component.scss'],
  animations: [
    trigger('fade', [
      state('fadeIn', style({
        opacity: '1',
        // width: '*',
        // height: '*',
      })),
      state('fadeOut', style({
        opacity: '0',
        // width: '0px',
        // height: '0px',
      })),
      transition('* => fadeOut', [
        animate('0.5s')
      ]),
      transition('* => fadeIn', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class LCRPageLayoutComponent implements OnInit {
  @Input() expandRightEvent: EventEmitter<any>;

  retractedCenter: boolean = false;
  clearContentCenter: boolean = false;
  retractedRight: boolean = false;
  clearContentRight: boolean = false;

  windowWidth: number;
  constructor() { }

  ngOnInit(): void {
    this.onWindowResize();
    if (this.expandRightEvent) {
      this.expandRightEvent.subscribe(() => {
        if (this.windowWidth < 1920) {
          this.expandRight();
        }
      });
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.windowWidth = document.body.getBoundingClientRect().width;
    if (this.windowWidth < 1920){
      this.retractRight();
    }

    if (this.windowWidth >= 1920){
      this.resetWindow();
    }
  }

  retractCenter(): void {
    this.clearContentCenter = true;
    setTimeout( () => {
      this.retractedCenter = true;
    }, 0);
  }

  expandCenter(): void {
    this.clearContentCenter = false;
    setTimeout( () => {
      this.retractedCenter = false;
      this.retractedRight = true;
      this.clearContentRight = true;
    }, 0);
  }

  retractRight(): void {
    this.clearContentRight = true;
    setTimeout( () => {
      this.retractedRight = true;
    }, 0);
  }

  expandRight(): void {
    this.clearContentRight = false;
    setTimeout( () => {
      this.retractedRight = false;
      this.retractedCenter = true;
      this.clearContentCenter = true;
    }, 0);
  }

  private resetWindow() {
    this.retractedRight = false;
    this.retractedCenter = false;
    this.clearContentCenter = false;
    this.clearContentRight = false;
  }
}
